import { render, staticRenderFns } from "./Form812.vue?vue&type=template&id=0fc3d4cc&scoped=true&"
import script from "./Form812.vue?vue&type=script&lang=js&"
export * from "./Form812.vue?vue&type=script&lang=js&"
import style0 from "./Form812.vue?vue&type=style&index=0&id=0fc3d4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc3d4cc",
  null
  
)

export default component.exports